export default __webpack_public_path__ + "static/ASLA_AptosBollard_3-4e7e814d03b048a93c3b38e94f058e2d.png";